'use strict';

const i18next = require('i18next');

class ErrorView {
  constructor() {

    this.block = document.getElementById('js-upgrade-error-block');
    this.text = document.getElementById('js-upgrade-error-text');

    this.errors = {
      insufficient_funds: i18next.t('Please top up the balance of your card to complete the pricing plan upgrade'),
      default: `${i18next.t('The payment is not completed. Please contact')}<a href="">support@amzscout.net</a>${i18next.t(' to complete the pricing plan upgrade.')}`
    }
  }

  displayError(code) {
    this.text.innerText = this.errors[code] || this.errors.default;
    this.displayBlock(true);
  }

  displayBlock(status) {
    this.block.style.display = status ? 'flex' : 'none';
  }
}

module.exports = ErrorView;
